<div class="p-4">
  <div class="general-box">
    <app-tab-menu-simple
      class="w-[-webkit-fill-available]"
      [tabs]="analyticsRouter"
      (changeSelected)="changeSelected($event.url ?? '', $event.indexSelected)"
      [titule]="'boards.title' | translate"
    ></app-tab-menu-simple>

    <div class="flex gap-4 xl:flex-row flex-col">
      <mat-card class="chart-card w-full">
        <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
          <div class="flex items-center text-general-subtitle">
            {{ 'boards.monthlyPortfolioPerformance' | translate }} {{ currentYear }}
          </div>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="p-1">
          @if (chartOptions) {
            <div>
              <apx-chart
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [xaxis]="chartOptions.xaxis"
                [yaxis]="chartOptions.yaxis"
                [colors]="chartOptions.colors"
                [stroke]="chartOptions.stroke"
                [markers]="chartOptions.markers"
                [legend]="chartOptions.legend"
              >
              </apx-chart>
            </div>
          } @else {
            <div class="d-flex-center p-4">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="chart-card w-full">
        <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
          <div class="flex items-center text-general-subtitle">
            {{ 'boards.monthlyDetail' | translate }}:
            {{ nombreMesSeleccionado || 'boards.selectAMonth' | translate }}
          </div>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content
          class="p-1"
          style="min-height: 25rem; display: flex; align-items: center; justify-content: center"
        >
          @if (mostrarChart && chartPieOptions) {
            <div style="width: 100%">
              <apx-chart
                [series]="chartPieOptions.series!"
                [chart]="chartPieOptions.chart!"
                [labels]="chartPieOptions.labels!"
                [dataLabels]="chartPieOptions.dataLabels!"
                [legend]="chartPieOptions.legend!"
                [colors]="chartPieOptions.colors!"
                [tooltip]="chartPieOptions.tooltip!"
              >
              </apx-chart>
            </div>
          } @else {
            <div class="text-muted">
              <p>{{ 'boards.selectPoint' | translate }}</p>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
    <div class="flex gap-4 xl:flex-row flex-col">
      <mat-card class="chart-card w-full">
        <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
          <div class="flex items-center text-general-subtitle">
            {{ 'boards.accumulatedOverdueAccounts' | translate }} {{ currentYear }}
          </div>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="p-2">
          @if (chartExpiredPortfolioOptions) {
            <div>
              <apx-chart
                [series]="chartExpiredPortfolioOptions.series"
                [chart]="chartExpiredPortfolioOptions.chart"
                [xaxis]="chartExpiredPortfolioOptions.xaxis"
                [yaxis]="chartExpiredPortfolioOptions.yaxis"
                [colors]="chartExpiredPortfolioOptions.colors"
                [tooltip]="chartExpiredPortfolioOptions.tooltip"
                [title]="chartExpiredPortfolioOptions.title"
                [dataLabels]="chartExpiredPortfolioOptions.dataLabels"
              >
              </apx-chart>
            </div>
          } @else {
            <div class="d-flex-center p-4">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          }
        </mat-card-content>
      </mat-card>

      @if (dataSourceDetailExpiredPortfolioAccumulated.data.length > 0 || loadingTable) {
        <mat-card class="chart-card w-full">
          <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
            <div class="flex items-center text-general-subtitle">
              {{ 'boards.accumulatedOverduePortfolioForTheMonth' | translate }} :
              {{ nameMonthWallet }}
            </div>
          </mat-card-header>
          <app-input-general
            class="w-100 px-4"
            [label]="'boards.filterTable'"
            [formControlGeneral]="inputSearchDetailExpiredPortfolioAccumulated"
          >
          </app-input-general>
          <mat-card-content class="p-0">
            @if (loadingTable) {
              <div class="d-flex justify-content-center p-4">
                <mat-spinner [diameter]="50"></mat-spinner>
              </div>
            }

            @if (!loadingTable) {
              <div class="flex flex-col gap-1">
                <app-table-general-simple
                  [dataSource]="dataSourceDetailExpiredPortfolioAccumulated"
                  [buttonEvent]="false"
                  [headers]="[
                    { value: 'client', description: 'Cliente' },
                    { value: 'dueDate', description: 'Fecha Exigible' },
                    { value: 'quotationId', description: 'Cotización' },
                    { value: 'amount', description: '$ Monto' },
                  ]"
                  [headerSorts]="['client', 'dueDate', 'quotationId', 'amount']"
                  (sortTable)="sortTables($event, dataSourceDetailExpiredPortfolioAccumulated)"
                  [totalAmount]="totalPortfolio"
                ></app-table-general-simple>
                <mat-paginator
                  #MatPaginatorVencida
                  [pageSizeOptions]="[5, 10, 15]"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>

    <div class="flex gap-4 xl:flex-row flex-col">
      <mat-card class="chart-card w-full">
        <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
          <div class="flex items-center text-general-subtitle">
            {{ 'boards.amountsChargedPerMonth' | translate }} {{ currentYear }}
          </div>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="p-2">
          @if (chartPortfolioPaidMonthlyOptions) {
            <div>
              <apx-chart
                [series]="chartPortfolioPaidMonthlyOptions.series"
                [chart]="chartPortfolioPaidMonthlyOptions.chart"
                [xaxis]="chartPortfolioPaidMonthlyOptions.xaxis"
                [yaxis]="chartPortfolioPaidMonthlyOptions.yaxis"
                [colors]="chartPortfolioPaidMonthlyOptions.colors"
                [tooltip]="chartPortfolioPaidMonthlyOptions.tooltip"
                [legend]="chartPortfolioPaidMonthlyOptions.legend"
                [dataLabels]="chartPortfolioPaidMonthlyOptions.dataLabels"
              >
              </apx-chart>
            </div>
          } @else {
            <div class="d-flex-center p-4">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          }
        </mat-card-content>
      </mat-card>

      @if (dataSourceDetailPortfolioPaidMonthly.data.length > 0 || loadingTablePagos) {
        <mat-card class="chart-card w-full">
          <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
            <div class="flex items-center text-general-subtitle">
              {{ paymentType }}: {{ nameMonthPayments }}
            </div>
          </mat-card-header>

          <app-input-general
            class="w-100 px-4"
            [label]="'boards.filterTable'"
            [formControlGeneral]="inputSearchDetailPortfolioPaidMonthly"
          >
          </app-input-general>
          <mat-card-content class="p-0">
            @if (loadingTablePagos) {
              <div class="d-flex justify-content-center p-4">
                <mat-spinner [diameter]="50"></mat-spinner>
              </div>
            }

            @if (!loadingTablePagos) {
              <div class="flex flex-col gap-1">
                <app-table-general-simple
                  [dataSource]="dataSourceDetailPortfolioPaidMonthly"
                  [buttonEvent]="false"
                  [headers]="[
                    { value: 'client', description: 'Cliente' },
                    { value: 'registrationDate', description: 'Fecha Registro' },
                    { value: 'depositDate', description: 'Fecha Deposito' },
                    { value: 'quotationId', description: 'Cotización' },
                    { value: 'amount', description: '$ Monto' },
                  ]"
                  [headerSorts]="[
                    'client',
                    'registrationDate',
                    'depositDate',
                    'quotationId',
                    'amount',
                  ]"
                  (sortTable)="sortTables($event, dataSourceDetailPortfolioPaidMonthly)"
                  [totalAmount]="totalPayments"
                ></app-table-general-simple>
                <mat-paginator
                  #MatPaginatorPagos
                  [pageSizeOptions]="[5, 10, 15]"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>

    <div class="flex gap-4 xl:flex-row flex-col">
      <mat-card class="chart-card w-full">
        <mat-card-header class="bg-(--comp-home-surface-bg) text-white flex items-center">
          <div class="flex items-center text-general-subtitle">
            {{ 'boards.quotationWorkflow' | translate }}
          </div>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="p-2">
          @if (chartWorkflowOptions) {
            <div>
              <apx-chart
                [series]="chartWorkflowOptions.series"
                [chart]="chartWorkflowOptions.chart"
                [xaxis]="chartWorkflowOptions.xaxis"
                [yaxis]="chartWorkflowOptions.yaxis"
                [colors]="chartWorkflowOptions.colors"
                [plotOptions]="chartWorkflowOptions.plotOptions"
                [tooltip]="chartWorkflowOptions.tooltip"
                [dataLabels]="chartWorkflowOptions.dataLabels"
              >
              </apx-chart>
            </div>
          } @else {
            <div class="d-flex justify-content-center p-4">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
